<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div class="flex">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-input
          v-model="distributeConfigName"
          size="small"
          clearable
          class="w-200px mr-10px ml-10px"
          placeholder="分发配置名称"
        ></el-input>
        <el-select
          v-model="typeName"
          class="w-200px mr-10px"
          placeholder="主数据类型"
          filterable
          clearable
          size="small"
        >
          <el-option
            v-for="item in masterDataTypeList"
            :key="item.id"
            :label="item.typeName"
            :value="item.typeName"
            @click.native="clickMasterType(item)"
          ></el-option>
        </el-select>
        <el-select
          v-model="classId"
          class="w-200px mr-10px"
          placeholder="主数据名称"
          filterable
          clearable
          size="small"
        >
          <el-option
            v-for="item in classIdList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="datetimerange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="mr-10px"
        ></el-date-picker>
        <el-button type="primary" @click="getDistributeList">搜索</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button @click="clickCreate" type="primary" :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button @click="clickDelete" type="danger" :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
        <el-button @click="exportFile" :disabled="!$hasAccess('export')" :loading="exportLoading"
          >导出</el-button
        >
      </div>
      <el-table
        v-loading="tableLoading"
        border
        :data="dataList"
        height="calc(100% - 106px)"
        class="mt-20px"
        :row-key="(record) => record.id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip label="分发配置名称" prop="name"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="分发主数据类型"
          prop="typeName"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="接口地址" prop="apiAddress"></el-table-column>
        <el-table-column label="创建时间" prop="createdTime" width="160"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="150">
          <template #default="{ row }">
            <el-button :disabled="!$hasAccess('update')" @click.stop="clickEdit(row)" size="mini">{{
              $t('edit')
            }}</el-button>
            <el-button
              :disabled="!$hasAccess('delete')"
              @click.stop="deleteAttr(row)"
              size="mini"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        @current-change="getDistributeList"
        @size-change="sizeChange"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next"
        :total="recordCount"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import stdClassListService from '@/services/stdClassListService'
import MasterDataManageService from '@/services/masterDataManageService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  components: { selectStandardId },
  data() {
    return {
      distributeConfigName: '',
      standardId: localStorage.getItem('standardId'),
      datetimerange: [],
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      dataList: [],
      totalSelection: [],
      masterDataTypeList: [],
      masterDataId: '',
      typeName: '', // 分发主数据类型搜索字段
      exportLoading: false,
      tableLoading: false,
      classIdList: [],
      classId: '',
    }
  },
  watch: {
    standardId: {
      handler(newVal) {
        if (newVal) {
          this.reset()
          // this.getMasterDataType()
        }
      },
    },
  },
  methods: {
    // 根据主数据类型id获取实体数据
    async getClassList(id) {
      const parameter = {
        // standard_id: this.standardId,
        keyword: '',
        pageno: 1,
        pagesize: 999,
        data_type: 1,
        approve_status: 1,
        data_main_type_id: id,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classIdList = res.data
      }
    },
    updateStandardId(val) {
      this.standardId = val
    },
    async clickMasterType(item) {
      this.classId = ''
      await this.getClassList(item.id)
    },
    /**
     * @function 获取主数据类型
     */
    async getMasterDataType() {
      // const params = {
      //   StandardId: this.standardId,
      // }
      const res = await MasterDataManageService.getList()
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.masterDataTypeList = res.data
      } else {
        this.masterDataTypeList = []
      }
    },

    reset() {
      this.distributeConfigName = ''
      this.datetimerange = []
      this.typeName = ''
      this.classId = ''
      this.getDistributeList()
    },

    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.pageNo = 1
      this.getDistributeList()
    },

    /**
     * @function 导出
     */
    async exportFile() {
      const id = _.map(this.totalSelection, (i) => {
        return i.id
      })
      this.exportLoading = true
      const res = await MasterDataManageService.exportDistributeList({
        ids: id,
        startDate: this.datetimerange.length ? this.datetimerange[0] : '',
        endDate: this.datetimerange.length ? this.datetimerange[1] : '',
        name: this.distributeConfigName,
        typeName: this.typeName,
        StandardId: this.standardId,
        ClassId: this.classId,
      })
      this.exportLoading = false
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`主数据分发配置${time}`, res)
      }
    },
    handleSelectionChange(val) {
      this.totalSelection = val
    },
    deleteAttr(item) {
      this.$confirm('是否确定要删除所选数据!', this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const res = await MasterDataManageService.deleteDistributeConfig([item.id])
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: res.msg,
          })
          this.getDistributeList()
        }
      })
    },

    /**
     * @function 点击删除
     */
    clickDelete() {
      if (!this.totalSelection.length) {
        this.$message({
          type: 'warning',
          message: '请选择删除项',
        })
        return
      }
      this.$confirm('是否确定要删除所选数据!', this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const ids = _.map(this.totalSelection, (i) => {
          return i.id
        })
        const res = await MasterDataManageService.deleteDistributeConfig(ids)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: res.msg,
          })
          this.getDistributeList()
        }
      })
    },

    /**
     * @function 点击编辑
     * @param {object} item
     */
    clickEdit(item) {
      this.$router.push({
        path: './operate-distribute-config',
        query: {
          item: encodeURIComponent(JSON.stringify(item)),
          type: 'edit',
        },
      })
    },

    /**
     * @function 获取列表
     */
    async getDistributeList() {
      this.tableLoading = true
      const params = {
        SkipCount: this.pageNo,
        MaxResultCount: this.pageSize,
        Sorting: '',
        StartDate: this.datetimerange.length ? this.datetimerange[0] : '',
        EndDate: this.datetimerange.length ? this.datetimerange[1] : '',
        Name: this.distributeConfigName,
        TypeName: this.typeName,
        StandardId: this.standardId,
        ClassId: this.classId,
      }
      const res = await MasterDataManageService.getMasterDistributeList(params)
      this.tableLoading = false
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.dataList = res.data
        this.recordCount = res.totalCount
      } else {
        this.dataList = []
        this.recordCount = 0
      }
    },

    /**
     * @function 点击新增
     */
    clickCreate() {
      this.$router.push({
        path: './operate-distribute-config?type=add',
      })
    },
  },

  async created() {
    this.getMasterDataType()
    if (this.standardId) {
      this.getDistributeList()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

.input-width {
  width: 200px;
}

</style>
